import React from 'react';
import { TextField, Autocomplete, FormControl, RadioGroup, FormControlLabel, Radio, Checkbox, FormGroup } from '@mui/material';

function isNumeric(str, dot) {
  if (str === ',') return false;
  if (str === '.' && !dot) return true;
  if (typeof str != "string") return false;
  return !isNaN(str) && !isNaN(parseFloat(str)); 
}

export default class Detalles extends React.Component{
  constructor(props){
    super(props);
    this.state={ }
  }

  validarNumero(campo, previo, nuevo){
    const dot = previo.includes('.');
    if(nuevo < previo) return(this.props.editar(campo, nuevo));
    if (isNumeric(nuevo[nuevo.length - 1],dot))
      return(this.props.editar(campo, nuevo))
  }

  render(){
    const {juzgadoSelec,defensoriaSelec,plazo_horas,habil,observaciones, tipo} = this.props.datos;
    const {juzgados, defensorias, editar} = this.props;
    return(
      <div style={{width:'100%', borderRadius:10, backgroundColor:'white', padding:10, margin:10, display:'flex', flexDirection:'column', alignItems:'center'}}>
        <div style={{display:'flex', flexDirection:'row', width:'100%'}}>
          <FormControl style={{flex:2, marginLeft:10}}>
            <RadioGroup
              aria-labelledby="demo-radio-buttons-group-label"
              defaultValue="juzgado"
              name="tipo"
              style={{display:'flex', flexDirection:'row', width:'100%', justifyContent:'space-between', overflow:'hidden'}}
              value={tipo}
              onChange={(e)=>editar('tipo',e.target.value)}
            >
              <FormControlLabel value="juzgado" control={<Radio />} label="Juzgado" />
              <FormControlLabel value="defensoria" control={<Radio />} label="Defensoría/Fiscalía/Etc." />
            </RadioGroup>
          </FormControl>
          {tipo === 'juzgado' && 
            <Autocomplete
              value={juzgadoSelec}
              onChange={(e,n) => editar('juzgadoSelec',n)}
              isOptionEqualToValue={(option, value) => option.id === value.id }
              options={juzgados}
              getOptionLabel={(option) => `N°${option.numero} - ${option.nombre} - ${option.materia} - ${option.localidad} `}
              size="small"
              disableClearable
              style={{margin:'5px 1px',flex:3, fontSize:5}}
              fontSize="small"
              renderInput={(params) => <TextField {...params} label="Juzgados"/>}
            />
          }
          {tipo === 'defensoria' && 
            <Autocomplete
              value={defensoriaSelec}
              onChange={(e,n) => editar('defensoriaSelec',n)}
              isOptionEqualToValue={(option, value) => option.id === value.id }
              options={defensorias}
              getOptionLabel={(option) => (option.localidad !== null ? option.localidad : option.nombre)}
              size="small"
              disableClearable
              style={{margin:'5px 1px',flex:3, fontSize:5}}
              fontSize="small"
              renderInput={(params) => <TextField {...params} label="Defensorías"/>}
            />
          }
          <TextField
            size="small"
            style={{flex:1,textAlign:'center',minWidth:0,margin:'5px 1px'}}
            label="Plazo vencimiento"
            placeholder='En HORAS'
            value={plazo_horas}
            onChange={(e) => this.validarNumero('plazo_horas',plazo_horas, e.target.value)}
            variant="outlined"
          />
          <FormGroup
            style={{flex:0.7, textAlign:'center', alignItems:'center', justifyContent:'center', display:'flex', overflow:'hidden'}}
          >
            <FormControlLabel 
              control={
                <Checkbox 
                  checked={habil}
                  onChange={(e) => editar('habil', e.target.checked)}
                />
              } 
              label="Hábil" 
            />
          </FormGroup>
        </div>
        <div style={{display:'flex', flexDirection:'row', width:'100%'}}>
          <TextField
            size="small"
            style={{flex:1,textAlign:'center',minWidth:0,margin:'5px 1px'}}
            label="Observaciones"
            placeholder='Opcional'
            value={observaciones}
            onChange={(e) => editar('observaciones',e.target.value)}
            variant="outlined"
            multiline
            rows={4}
          />
        </div>
        <div style={{display:'flex', flexDirection:'row', width:'100%'}}>
        </div>
      </div>
    )
  }
}